import { Languages } from "./LanguagesI"

export interface PageI {
    header_loaded: boolean,
    type: PageType,
    props: any,
    settings: {
        language: Languages
    },
    notifications: object[],
    popup: PopUpType | null
}

export enum PageType {
    'entrance' = 'entrance',
    'log_in_form' = 'log_in_form',
    'create_account' = 'create_account',
    'create_online_account' = 'create_online_account',
    'create_account_verify_email' = 'create_account_verify_email',
    'log_out_form' = 'log_out_form',
    'email_send' = 'email_send',
    'email_not_found' = 'email_not_found',
    'create_password' = 'create_password',
    'verify_email' = 'verify_email',
    'forgotton_password' = 'forgotton_password',
    'forgotton_password_email_not_found' = 'forgotton_password_email_not_found',
    'forgotton_password_email_send' = 'forgotton_password_email_send',
    'reset_password' = 'reset_password',
    'user_profile' = 'user_profile',
    'memberships' = 'memberships',
    'reservations' = 'reservations',
    'ehsop' = 'eshop',
    'credit_history' = 'credit_history',
    'lessons' = 'lessons',
    'account_detail' = 'account_detail'
}
export const loggedUserPages = [
    'account_detail', 
    'lessons', 
    'credit_history', 
    'eshop', 
    'reservations', 
    'memberships', 
    'user_profile'
]



export enum PopUpType {
    "buy_membership" = "buy_membership",
    "buy_credits" = "buy_credits"
} 

